import styled from 'styled-components'
import { getFontStyle, PainPointAltIcon } from '@diversioteam/diversio-ds'

export const PublishedStatusWrapper = styled.div`
    grid-area: published-status;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-radius: 15px;
    border: 1.5px solid ${({ theme }) => theme.colors.primaryGray2};
    position: relative;
`

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const StatusIcon = styled(PainPointAltIcon)`
    position: absolute;
    top: 12px;
    right: 12px;
`

export const DateInfo = styled.div`
    margin-top: auto;
    display: flex;
    flex-direction: column;
    color: ${({ theme }) => theme.colors.secondary500};

    ${getFontStyle('p03Regular')}

    span {
        display: block;
    }
`
